module.exports = __webpack_public_path__ + "img/1536516978.73797b19.jpg";